import React from 'react';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import ServicesHomeTwo from '../HomeTwo/ServicesHomeTwo';
import Drawer from '../Mobile/Drawer';
import Banner from './Banner';
import FooterHomeOne from './FooterHomeOne';
import HeroHomeOne from './HeroHomeOne';
import HomeOneHeader from './HomeOneHeader';
import PricingHomeOne from './PricingHomeOne';
import SaveUterus from './SaveUterus';
import ServicesHomeOne from './ServicesHomeOne';
import TeamHomeOne from './TeamHomeOne';
import TrafficHomeOne from './TrafficHomeOne';

function HomeOne() {
    const [drawer, drawerAction] = useToggle(false);

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HomeOneHeader action={drawerAction.toggle} />
            <Banner />
            <HeroHomeOne />
            <ServicesHomeOne />
            <SaveUterus />
            <TrafficHomeOne />
            <ServicesHomeTwo className="pt-90" />
            <TeamHomeOne />
            <PricingHomeOne />
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default HomeOne;
